// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IEnrollmentReportDto } from './IEnrollmentReportDto';
import {
    IEnrollmentReportDtoFromJSON,
    IEnrollmentReportDtoFromJSONTyped,
    IEnrollmentReportDtoToJSON,
    IEnrollmentReportDtoToJSONTyped,
} from './IEnrollmentReportDto';

/**
 * 
 * @export
 * @interface IEnrollmentRecordDto
 */
export interface IEnrollmentRecordDto {
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentRecordDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentRecordDto
     */
    request_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentRecordDto
     */
    status?: IEnrollmentRecordDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IEnrollmentRecordDto
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentRecordDto
     */
    raw_record?: string;
    /**
     * 
     * @type {IEnrollmentReportDto}
     * @memberof IEnrollmentRecordDto
     */
    report?: IEnrollmentReportDto;
}

/**
* @export
* @enum {string}
*/
export enum IEnrollmentRecordDtoStatusEnum {
    RECEIVED = 'RECEIVED',
    PROCESSING = 'PROCESSING',
    PROCESSED = 'PROCESSED',
    WAITING = 'WAITING'
}


/**
 * Check if a given object implements the IEnrollmentRecordDto interface.
 */
export function instanceOfIEnrollmentRecordDto(value: object): value is IEnrollmentRecordDto {
    return true;
}

export function IEnrollmentRecordDtoFromJSON(json: any): IEnrollmentRecordDto {
    return IEnrollmentRecordDtoFromJSONTyped(json, false);
}

export function IEnrollmentRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEnrollmentRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'request_id': json['requestId'] == null ? undefined : json['requestId'],
        'status': json['status'] == null ? undefined : json['status'],
        'created_at': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'raw_record': json['rawRecord'] == null ? undefined : json['rawRecord'],
        'report': json['report'] == null ? undefined : IEnrollmentReportDtoFromJSON(json['report']),
    };
}

export function IEnrollmentRecordDtoToJSON(json: any): IEnrollmentRecordDto {
    return IEnrollmentRecordDtoToJSONTyped(json, false);
}

export function IEnrollmentRecordDtoToJSONTyped(value?: IEnrollmentRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'requestId': value['request_id'],
        'status': value['status'],
        'createdAt': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'rawRecord': value['raw_record'],
        'report': IEnrollmentReportDtoToJSON(value['report']),
    };
}

